import { rtkAPI } from 'rtk/rtkSetup';
import api from 'util/api';
import { serializeRtkQueryError } from 'util/rtkQueryError';

export const NOTARY_SHARE_TAGS = {
  ASSOCIATIONS: 'NotaryAssociations'
};

const enhancedApi = rtkAPI.enhanceEndpoints({
  addTagTypes: [NOTARY_SHARE_TAGS.ASSOCIATIONS]
});

export const isSelectiveAssociation = item => {
  const status = String(item?.Association?.Status || '').toUpperCase();
  return item?.Association?.ShareAll === false && status === 'ACCEPTED';
};

export const notaryShareApi = enhancedApi.injectEndpoints({
  endpoints: build => ({
    listNotaryAssociations: build.query({
      async queryFn(args) {
        const { skip = 0, maxResults = 100 } = args || {};
        try {
          const res = await api.NotaryAssociations.list({
            skip,
            maxresults: maxResults
          });
          return { data: res };
        } catch (error) {
          return { error: serializeRtkQueryError(error) };
        }
      },
      keepUnusedDataFor: 60,
      providesTags: [{ type: NOTARY_SHARE_TAGS.ASSOCIATIONS, id: 'LIST' }]
    }),

    shareJournalEntries: build.mutation({
      async queryFn({ adminGuid, entryGuids }) {
        try {
          const res = await api.NotaryShareEntries.share(adminGuid, entryGuids);
          return { data: res };
        } catch (error) {
          return { error: serializeRtkQueryError(error) };
        }
      }
    })
  })
});

export const {
  useListNotaryAssociationsQuery,
  useShareJournalEntriesMutation
} = notaryShareApi;
